import { Button, ButtonProps } from '@chakra-ui/react';
import { reactEvents } from '@bridge/reactEvents';
import { useTranslation } from 'react-i18next';

interface Props {
  customerId?: number;
  conceptId?: number;
  sourceArticleId?: number;
  variant?: ButtonProps['variant'];
}

export function CopyArticleButton({
  customerId,
  conceptId,
  sourceArticleId,
  variant = 'texas-light',
}: Props) {
  const { t } = useTranslation();

  return (
    <Button
      variant={variant}
      onClick={() =>
        reactEvents.routingChanged.dispatch({
          to: 'copyArticle',
          navObj: { customerId, conceptId, sourceArticleId },
        })
      }
    >
      {t('article.management.copyArticle')}
    </Button>
  );
}
